import { Injectable, inject } from '@angular/core';

import { Analytics } from '@core/analytics-types';

import type { OverdueTrackingEvent } from '../analytics/overdue-candidate.analytics';

@Injectable({ providedIn: 'root' })
export class OverdueCandidatesTrackingService {
  private readonly analytics = inject(Analytics);

  public track(event: OverdueTrackingEvent): void {
    this.analytics.track(event.name, event.properties);
  }
}
